import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["toThousands", "minusRight", "step", "disabled", "readOnly", "clsPrefix", "className", "delay", "onBlur", "onFocus", "iconStyle", "autoWidth", "onChange", "format", "precision", "toNumber", "hideActionButton", "handleBtnClick", "onStep", "displayCheckPrompt", "onPressEnter", "formatter", "style"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.number.max-safe-integer.js";
import "core-js/modules/es6.number.min-safe-integer.js";
import React, { Component } from "react";
import classnames from "classnames";
import InputGroup from "../../wui-input-group/src";
import FormControl from "../../wui-input/src";
import Message from "../../wui-message/src";
import PropTypes from "prop-types";
import i18n from "./i18n";
import { getComponentLocale } from "../../wui-locale/src/tool";
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  autoWidth: PropTypes.bool,
  precision: PropTypes.number,
  readOnly: PropTypes.bool,
  onPressEnter: PropTypes.func,
  decimalSeparator: PropTypes.string,
  format: PropTypes.func,
  formatter: PropTypes.func,
  //兼容antd属性
  delay: PropTypes.number,
  disabled: PropTypes.bool,
  toThousands: PropTypes.bool,
  locale: PropTypes.object,
  toNumber: PropTypes.bool,
  //回调函数内的值是否转换为数值类型
  displayCheckPrompt: PropTypes.bool,
  //是否显示超出限制范围之后的检验提示
  minusRight: PropTypes.bool,
  //负号是否在右边
  handleBtnClick: PropTypes.func,
  //加减按钮点击回调
  onStep: PropTypes.func,
  //兼容antd属性，作用同加减按钮点击回调
  hideActionButton: PropTypes.bool //隐藏加减按钮

};
var defaultProps = {
  value: null,
  step: 1,
  iconStyle: "double",
  autoWidth: false,
  max: null,
  min: null,
  precision: null,
  readOnly: false,
  decimalSeparator: '.',
  // format:() => {},
  // formatter: () => {},
  delay: 300,
  disabled: false,
  toThousands: false,
  locale: {},
  toNumber: true,
  displayCheckPrompt: false,
  minusRight: false,
  // onPressEnter: () => {},
  // onStep: () => {},
  // handleBtnClick: () => {},
  hideActionButton: false
}; //校验提示

function prompt(content) {
  Message.destroy();
  Message.create({
    content: content,
    color: "warninglight"
  });
}
/**
 * 千分符
 * @param {要转换的数据} num
 */


function toThousands(number) {
  if (number === "") return "";
  if (number === "0") return "0";
  var num = (number || 0).toString();
  var integer = num.split(".")[0];
  var decimal = num.split(".")[1] || "";
  var result = "";

  while (integer.length > 3) {
    result = "," + integer.slice(-3) + result;
    integer = integer.slice(0, integer.length - 3);
  }

  if (integer) {
    result = integer + result;

    if (num == "." || num.indexOf(".") == num.length - 1) {
      result = result + "." + decimal;
    } else if (decimal) {
      result = result + "." + decimal;
    }
  }

  if (result[0] == "-") {
    result = result.replace("-,", "-");
  }

  return result;
}

function setCaretPosition(ctrl, pos, need) {
  if (ctrl && need) {
    if (ctrl.setSelectionRange) {
      ctrl.focus();
      ctrl.setSelectionRange(pos, pos); // IE8 and below
    } else if (ctrl.createTextRange) {
      var range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd("character", pos);
      range.moveStart("character", pos);
      range.select();
    }
  }
}

var InputNumber = (_dec = WebUI({
  name: "input-number",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(_props) {
    var _this;

    _classCallCheck(this, InputNumber);

    _this = _super.call(this, _props); // 初始化状态，加减按钮是否可用，根据当前值判断

    _defineProperty(_assertThisInitialized(_this), "judgeValue", function (props, oldValue) {
      var currentValue;
      var currentMinusDisabled = false;
      var currentPlusDisabled = false;
      var value = props.value,
          min = props.min,
          max = props.max,
          precision = props.precision,
          defaultValue = props.defaultValue,
          displayCheckPrompt = props.displayCheckPrompt;
      if (!max && max !== 0 && _this.state) max = _this.state.max;
      if (!min && min !== 0 && _this.state) min = _this.state.min;

      if (props.minusRight) {
        value = value.toString();

        if (value.indexOf("-") != -1) {
          //所有位置的负号转到前边
          value = value.replace("-", "");
          value = "-" + value;
        }

        value = Number(value);
      }

      if (value != undefined && value != null) {
        if (value === "") {
          currentValue = "";
          return {
            value: "",
            minusDisabled: false,
            plusDisabled: false
          };
        } else {
          currentValue = Number(value) || 0;
        }
      } else if (defaultValue !== undefined && defaultValue !== null) {
        currentValue = defaultValue;
      } //lse if (min&&(value!='')) {//mdd中提出bug
      //currentValue = min;
      //}
      else if (value === "0" || value === 0) {
        currentValue = 0;
      } else {
        //NaN
        if (oldValue || oldValue === 0 || oldValue === "0") {
          currentValue = oldValue;
        } else {
          //value为空
          return {
            value: "",
            minusDisabled: false,
            plusDisabled: false
          };
        }
      }

      if (currentValue == -Infinity) {
        return {
          value: min,
          minusDisabled: true,
          plusDisabled: false
        };
      }

      if (currentValue == Infinity) {
        return {
          value: max,
          minusDisabled: false,
          plusDisabled: true
        };
      }

      var local = getComponentLocale(props, _this.context, "InputNumber", function () {
        return i18n;
      });

      if (min && currentValue <= min) {
        if (displayCheckPrompt) prompt(local["msgMin"]);
        currentMinusDisabled = true;
        currentValue = min;
      }

      if (max && currentValue >= max) {
        if (displayCheckPrompt) prompt(local["msgMax"]);
        currentPlusDisabled = true;
        currentValue = max;
      }

      if (props.hasOwnProperty("precision")) {
        // currentValue = Number(currentValue).toFixed(precision);
        currentValue = _this.getPrecision(currentValue);
      }

      if (props.minusRight) {
        currentValue = currentValue.toString();

        if (currentValue.indexOf("-") != -1) {
          //负号转到后边
          currentValue = currentValue.replace("-", "");
          currentValue = currentValue + "-";
        }
      }

      return {
        value: currentValue,
        minusDisabled: currentMinusDisabled,
        plusDisabled: currentPlusDisabled
      };
    });

    _defineProperty(_assertThisInitialized(_this), "numToFixed", function (value, fixed, type) {
      value = String(value);
      if (!value && value !== "0") return value;
      if (!fixed && String(fixed) !== "0") return value;
      var preIndex = value.indexOf(".");
      if (value.indexOf(".") === -1) return value;
      preIndex++;
      var endIndex = preIndex + fixed;
      var precValue = value.substr(preIndex, endIndex) + "0000000000";

      if (type) {
        return (Number(value) + 1e-14).toFixed(fixed);
      }

      return value.split(".")[0] + "." + precValue.substr(0, fixed);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, e) {
      var selectionStart = _this.input.selectionStart == undefined ? _this.input.input.selectionStart : _this.input.selectionStart;
      _this.selectionStart = selectionStart;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          toNumber = _this$props.toNumber,
          minusRight = _this$props.minusRight,
          antd = _this$props.antd;

      if (antd) {
        e = value;
        value = e.target.value;
      }

      if (value === "") {
        onChange && onChange(value, e);

        _this.setState({
          value: value,
          showValue: ""
        });

        return;
      } // value = this.unThousands(value);


      if (minusRight) {
        if (value.match(/-/g) && value.match(/-/g).length > 1) return;
      }

      var thousandth = _this.isThousandth(value); // 是否是千分位


      if (isNaN(value) && value !== "." && value !== "-" && !thousandth) return;

      if (value.indexOf(".") !== -1) {
        //小数最大值处理
        var prec = String(value.split(".")[1]).replace("-", "");
        if (_this.props.precision === 0 && (prec === "" || prec != "")) return;
        if (_this.props.precision && prec.length > _this.props.precision) return; // if (prec.length > 8) return;
      }

      _this.setState({
        value: value,
        showValue: toThousands(value)
      });

      if (value === "-") {
        onChange && onChange(value, e);
      } else if (value == "." || value.indexOf(".") == value.length - 1) {
        //当输入小数点的时候
        onChange && onChange(value, e);
      } else if (value[value.indexOf(".") + 1] == 0) {
        //当输入 d.0 的时候，不转换Number
        onChange && onChange(value, e);
      } else {
        toNumber ? onChange && onChange(Number(value), e) : onChange && onChange(value, e);
      }

      if (_this.props.toThousands) {
        var stateShowValue = toThousands(_this.state.value);
        var showValue = toThousands(value);
        var addNumber = 0;
        var delNumber = 0;
        var reg = /[0-9]/;

        for (var i = 0; i < selectionStart; i++) {
          if (!reg.test(showValue[i])) addNumber += 1;
        }

        for (var j = 0; j < selectionStart; j++) {
          if (stateShowValue[j]) {
            if (!reg.test(stateShowValue[j])) delNumber += 1;
          }
        }

        var position = selectionStart + addNumber - delNumber;
        setCaretPosition(_this.input && _this.input.input, position, true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (value, e) {
      _this.focus = true;
      var _this$props2 = _this.props,
          onFocus = _this$props2.onFocus,
          min = _this$props2.min,
          max = _this$props2.max;

      if (onFocus) {
        onFocus(_this.getPrecision(_this.state.value), e);
      } else {
        _this.forceUpdate();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getFullNum", function (num) {
      //处理非数字
      if (isNaN(num)) {
        return num;
      } //处理不需要转换的数字


      var str = "" + num;

      if (!/e/i.test(str)) {
        return num;
      }

      var _precision = _this.props.precision ? _this.props.precision : 18;

      return Number(num).toFixed(_precision).replace(/\.?0+$/, "");
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (v, e) {
      _this.focus = false;
      var _this$props3 = _this.props,
          onBlur = _this$props3.onBlur,
          precision = _this$props3.precision,
          onChange = _this$props3.onChange,
          toNumber = _this$props3.toNumber,
          max = _this$props3.max,
          min = _this$props3.min,
          displayCheckPrompt = _this$props3.displayCheckPrompt,
          minusRight = _this$props3.minusRight,
          round = _this$props3.round;
      if (!max && max !== 0) max = _this.state.max;
      if (!min && min !== 0) min = _this.state.min;
      var local = getComponentLocale(_this.props, _this.context, "InputNumber", function () {
        return i18n;
      });
      v = _this.state.value; //在onBlur的时候不需要活输入框的只，而是要获取state中的值，因为有format的时候就会有问题。

      if (v === "" || !v) {
        _this.setState({
          value: v
        });

        onChange && onChange(v);
        onBlur && onBlur(v, e);
        return;
      } // let value = this.unThousands(v);


      var value = _this.numToFixed(v, precision, round);

      if (minusRight) {
        if (value.indexOf("-") != -1) {
          //所有位置的负号转到前边
          value = value.replace("-", "");
          value = "-" + value;
        }
      }

      value = isNaN(Number(value)) ? 0 : Number(value);

      if ((max || max === 0) && value > max) {
        if (displayCheckPrompt) prompt(local["msgMax"]);
        value = max;
      }

      if ((min || min === 0) && value < min) {
        if (displayCheckPrompt) prompt(local["msgMin"]);
        value = min;
      }

      if (_this.props.hasOwnProperty("precision")) {
        // value = value.toFixed(precision);
        value = _this.getPrecision(value);
      }

      value = value.toString();

      if (minusRight && value.indexOf("-") != -1) {
        //负号转到后边
        value = value.replace("-", "");
        value = value + "-";
      }

      _this.setState({
        value: value,
        showValue: toThousands(value),
        placeholderShow: true
      });

      _this.detailDisable(value);

      if (toNumber && !minusRight) {
        onChange && onChange(Number(value));
        onBlur && onBlur(Number(value), e);
      } else {
        onChange && onChange(value, e);
        onBlur && onBlur(value, e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "delcommafy", function (num) {
      //去除千分位中的‘，’
      if (num && num != "undefined" && num != "null") {
        var numS = num;
        numS = numS.toString();
        numS = numS.replace(/,/gi, "");
        return numS;
      } else {
        return num;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "detailDisable", function (value) {
      var _this$props4 = _this.props,
          max = _this$props4.max,
          min = _this$props4.min,
          step = _this$props4.step;
      if (!max && max !== 0) max = _this.state.max;
      if (!min && min !== 0) min = _this.state.min;

      if (max && (value >= max || Number(value) + Number(step) > max)) {
        _this.setState({
          plusDisabled: true
        });
      } else {
        _this.setState({
          plusDisabled: false
        });
      }

      if (min && (value <= min || value - step < min)) {
        _this.setState({
          minusDisabled: true
        });
      } else {
        _this.setState({
          minusDisabled: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "minus", function (value, e) {
      var _this$props5 = _this.props,
          min = _this$props5.min,
          max = _this$props5.max,
          step = _this$props5.step,
          onChange = _this$props5.onChange,
          toNumber = _this$props5.toNumber;
      if (!max && max !== 0) max = _this.state.max;
      if (!min && min !== 0) min = _this.state.min;
      value = value === "-" ? 0 : value;

      if (typeof min === "undefined") {
        value = _this.detail(value, step, "reduce");
      } else {
        min = Number(min);

        if (value < min) {
          value = min;
        } else {
          var reducedValue = _this.detail(value, step, "reduce");

          if (reducedValue >= min) {
            value = reducedValue;
          }
        }
      }

      if (max) {
        max = Number(max);

        if (value > max) {
          value = max;
        }
      }

      _this.setState({
        value: value,
        showValue: toThousands(value)
      }, function () {
        _this.input.input.focus && _this.input.input.focus();
      });

      toNumber ? onChange && onChange(Number(value), e) : onChange && onChange(value, e);

      _this.handleBtnClick("down", value);

      _this.detailDisable(value);
    });

    _defineProperty(_assertThisInitialized(_this), "plus", function (value, e) {
      var _this$props6 = _this.props,
          max = _this$props6.max,
          min = _this$props6.min,
          step = _this$props6.step,
          onChange = _this$props6.onChange,
          toNumber = _this$props6.toNumber;
      if (!max && max !== 0) max = _this.state.max;
      if (!min && min !== 0) min = _this.state.min;
      value = value === "-" ? 0 : value;

      if (typeof max === "undefined") {
        value = _this.detail(value, step, "add");
      } else {
        max = Number(max);

        if (max && value > max) {
          value = max;
        } else {
          var addedValue = _this.detail(value, step, "add");

          if (max && addedValue <= max) {
            value = addedValue;
          }
        }
      }

      if (min) {
        min = Number(min);

        if (value < min) {
          value = min;
        }
      }

      _this.setState({
        value: value,
        showValue: toThousands(value)
      }, function () {
        _this.input.input.focus && _this.input.input.focus();
      });

      toNumber ? onChange && onChange(Number(value), e) : onChange && onChange(value, e);

      _this.handleBtnClick("up", value);

      _this.detailDisable(value);
    });

    _defineProperty(_assertThisInitialized(_this), "detail", function (value, step, type) {
      var precision = _this.props.precision;

      var valueFloat = _this.separate(value);

      var stepFloat = _this.separate(step);

      var ans;
      var stepFloatLength = stepFloat.toString().length;
      var valueFloatLength = valueFloat.toString().length;

      if (typeof precision === "undefined") {
        precision = Math.max(stepFloatLength, valueFloatLength);
      }

      var coefficient = Math.pow(10, Math.abs(stepFloatLength - valueFloatLength));

      if (type === "add") {
        ans = (value * coefficient + step * coefficient) / coefficient;
      } else {
        ans = (value * coefficient - step * coefficient) / coefficient;
      }

      return ans.toFixed(precision);
    });

    _defineProperty(_assertThisInitialized(_this), "isThousandth", function (value) {
      var regex = /(?:^[-]?[1-9]\d{0,2}(?:$|(?:,\d{3})*(?:$|(\.\d{1,2}$))))|(?:(?:^[0](\.\d{1,2})?)|(?:^[-][0]\.\d{1,2}))$/;
      return regex.test(value);
    });

    _defineProperty(_assertThisInitialized(_this), "separate", function (value) {
      if (value == null || value == undefined) {
        return "";
      } else {
        value = value.toString();

        if (value.indexOf(".") > -1) {
          return value.split(".")[1];
        } else {
          return "";
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlusMouseDown", function (e) {
      e.persist();
      e.nativeEvent.stopPropagation();
      e.nativeEvent.preventDefault();
      var _this$props7 = _this.props,
          delay = _this$props7.delay,
          disabled = _this$props7.disabled,
          readOnly = _this$props7.readOnly;
      var value = _this.state.value;
      if (disabled || readOnly) return;

      _this.plus(value, e);

      _this.clear();

      _this.timer = setTimeout(function () {
        _this.handlePlusMouseDown(e);
      }, delay);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReduceMouseDown", function (e) {
      e.persist();
      e.nativeEvent.stopPropagation();
      e.nativeEvent.preventDefault();
      var _this$props8 = _this.props,
          delay = _this$props8.delay,
          disabled = _this$props8.disabled,
          readOnly = _this$props8.readOnly;
      var value = _this.state.value;
      if (disabled || readOnly) return;

      _this.minus(value, e);

      _this.clear();

      _this.timer = setTimeout(function () {
        _this.handleReduceMouseDown(e);
      }, delay);
    });

    _defineProperty(_assertThisInitialized(_this), "getPrecision", function (value) {
      if (value == null || value == undefined) return value;
      if (!value && value === "") return value;
      value = String(value);
      value = value.indexOf("e") !== -1 ? _this.getFullNum(value) : value;
      var precision = _this.props.precision;
      if (precision === 0) return value;

      if (precision == undefined || value.indexOf(".") !== -1 && String(value.split(".")[1]).length === precision) {
        return value;
      }

      var before = value.substring(0, 1),
          len = value.length,
          after = value.substring(len - 1, len);
      before = before === "-" ? before : "";
      after = after === "-" ? after : ""; //是科学计数法，不replace -

      if (before) value = value.substring(1, len);
      if (after) value = value.substring(0, len - 1); // value = value.replace("-",'');

      var precV = "000000000000000000000000000000000000000000000000000000000000000000000000";

      if (value.indexOf(".") === -1) {
        precV = precV.substr(0, precision);
        precV = precV ? "." + precV : precV;

        if (!isNaN(value) && (value.indexOf("-") != -1 || value.indexOf("+") != -1) && value.indexOf("e") != -1) {//是科学计数法，不拼接0000000
        } else {
          value = value + precV;
        }
      }

      return before + Number(value).toFixed(precision) + after;
    });

    _defineProperty(_assertThisInitialized(_this), "handleBtnClick", function (type, value) {
      var _this$props9 = _this.props,
          onStep = _this$props9.onStep,
          handleBtnClick = _this$props9.handleBtnClick;
      handleBtnClick && handleBtnClick(type, value);
      onStep && onStep(type, value);
    });

    _defineProperty(_assertThisInitialized(_this), "isIE", function () {
      if (window) {
        if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "placeholderClick", function () {
      _this.input.input.focus();

      _this.setState({
        placeholderShow: false
      });
    });

    var data = _this.judgeValue(_props);

    _this.state = {
      value: data.value,
      max: Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1,
      min: Number.MIN_SAFE_INTEGER || (Math.pow(2, 53) - 1) * -1,
      minusDisabled: data.minusDisabled,
      plusDisabled: data.plusDisabled,
      showValue: toThousands(data.value),
      placeholderShow: true
    };
    _this.timer = null;
    _this.focus = false;
    _this.selectionStart = 0;
    return _this;
  } // unThousands = (number) =>{
  //     if(!number || number === "")return number;
  //     number = number.toString();
  //     return number.replace(new RegExp(this.props.formatSymbol,'g'),'');
  //     // return number.replace(/\,/g,'');
  // }

  /**
   * 校验value
   * @param {*} props
   * @param {原来的值} oldValue
   */


  _createClass(InputNumber, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var data = this.judgeValue(this.props);
      this.setState({
        value: data.value,
        showValue: toThousands(data.value)
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value === this.props.value) {
        return;
      }

      if (this.focus) {
        if (nextProps.value == Infinity || nextProps.value == -Infinity) {} else {
          var nextValue = nextProps.value;
          var isThousand = this.isThousandth(nextValue); // 是否是千分位

          if (isThousand) {
            nextValue = this.delcommafy(nextValue);
          }

          this.setState({
            value: nextValue,
            showValue: toThousands(nextValue)
          });
        }
      } else {
        var data = this.judgeValue(nextProps, this.state.value);
        this.setState({
          value: data.value,
          showValue: toThousands(data.value),
          minusDisabled: data.minusDisabled,
          plusDisabled: data.plusDisabled
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clear();
    }
    /**
     *  @memberof InputNumber
     * type 是否要四舍五入(此参数无效,超长不让输入)
     */

  }, {
    key: "render",
    value: function render() {
      var _classes,
          _this2 = this;

      var _this$props10 = this.props,
          toThousands = _this$props10.toThousands,
          minusRight = _this$props10.minusRight,
          step = _this$props10.step,
          disabled = _this$props10.disabled,
          readOnly = _this$props10.readOnly,
          clsPrefix = _this$props10.clsPrefix,
          className = _this$props10.className,
          delay = _this$props10.delay,
          onBlur = _this$props10.onBlur,
          onFocus = _this$props10.onFocus,
          iconStyle = _this$props10.iconStyle,
          autoWidth = _this$props10.autoWidth,
          onChange = _this$props10.onChange,
          format = _this$props10.format,
          precision = _this$props10.precision,
          toNumber = _this$props10.toNumber,
          hideActionButton = _this$props10.hideActionButton,
          handleBtnClick = _this$props10.handleBtnClick,
          onStep = _this$props10.onStep,
          displayCheckPrompt = _this$props10.displayCheckPrompt,
          onPressEnter = _this$props10.onPressEnter,
          formatter = _this$props10.formatter,
          style = _this$props10.style,
          others = _objectWithoutProperties(_this$props10, _excluded);

      var classes = (_classes = {}, _defineProperty(_classes, "".concat(clsPrefix, "-auto"), autoWidth), _defineProperty(_classes, "".concat(clsPrefix), true), _defineProperty(_classes, "".concat(clsPrefix, "-lg"), others.size === "lg"), _defineProperty(_classes, "".concat(clsPrefix, "-nm"), others.size === "nm"), _defineProperty(_classes, "".concat(clsPrefix, "-sm"), others.size === "sm"), _classes);
      var _this$state = this.state,
          value = _this$state.value,
          minusDisabled = _this$state.minusDisabled,
          plusDisabled = _this$state.plusDisabled,
          showValue = _this$state.showValue;
      value = precision != null && !this.focus ? this.getPrecision(value) : value;
      if (!format && formatter) format = formatter; //兼容处理

      value = format && !this.focus ? format(value) : value;
      value = String(value).indexOf("e") !== -1 ? this.getFullNum(value) : value;

      if (minusRight && String(value).indexOf("-") != -1) {
        value = String(value).replace("-", "") + "-";
      }

      var disabledCursor = disabled ? " disabled-cursor" : "";
      var disabledCon = disabled ? " disabled-con" : "";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-out"),
        style: others.style
      }, iconStyle === "double" ? /*#__PURE__*/React.createElement(InputGroup, {
        style: style,
        className: classnames(className, classes, disabledCon)
      }, this.isIE() && !value ? /*#__PURE__*/React.createElement("div", {
        onClick: this.placeholderClick,
        style: {
          display: this.state.placeholderShow ? "block" : "none"
        },
        className: "".concat(clsPrefix, "-placeholder")
      }, this.props.placeholder) : "", hideActionButton ? "" : /*#__PURE__*/React.createElement(InputGroup.Addon, {
        // onClick={()=>{minusDisabled?'':this.handleBtnClick('down')}}
        className: (minusDisabled && "disabled") + disabledCursor,
        onMouseDown: this.handleReduceMouseDown,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.clear();
        },
        onMouseUp: function onMouseUp() {
          return _this2.clear();
        }
      }, "-"), /*#__PURE__*/React.createElement(FormControl, _extends({}, others, {
        value: toThousands ? showValue : value,
        disabled: disabled,
        readOnly: readOnly,
        onPressEnter: onPressEnter,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        ref: function ref(_ref) {
          return _this2.input = _ref;
        }
      })), hideActionButton ? "" : /*#__PURE__*/React.createElement(InputGroup.Addon, {
        // onClick={()=>{plusDisabled?'':this.handleBtnClick('up')}}
        className: (plusDisabled && "disabled") + disabledCursor,
        onMouseDown: this.handlePlusMouseDown,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.clear();
        },
        onMouseUp: function onMouseUp() {
          return _this2.clear();
        }
      }, "+")) : /*#__PURE__*/React.createElement(InputGroup, {
        style: style,
        className: classnames(className, classes, disabledCon),
        simple: true
      }, this.isIE() && !value ? /*#__PURE__*/React.createElement("div", {
        onClick: this.placeholderClick,
        style: {
          display: this.state.placeholderShow ? "block" : "none"
        },
        className: "".concat(clsPrefix, "-placeholder")
      }, this.props.placeholder) : "", /*#__PURE__*/React.createElement(FormControl, _extends({}, others, {
        value: toThousands ? showValue : value,
        disabled: disabled,
        readOnly: readOnly,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        onPressEnter: onPressEnter,
        ref: function ref(_ref2) {
          return _this2.input = _ref2;
        }
      })), hideActionButton ? "" : /*#__PURE__*/React.createElement(InputGroup.Button, null, /*#__PURE__*/React.createElement("div", {
        className: classnames("icon-group")
      }, /*#__PURE__*/React.createElement("span", {
        // onClick={()=>{plusDisabled?'':this.handleBtnClick('up')}}
        onMouseDown: this.handlePlusMouseDown,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.clear();
        },
        onMouseUp: function onMouseUp() {
          return _this2.clear();
        },
        className: classnames("plus", {
          disabled: plusDisabled,
          "disabled-cursor": disabledCursor
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "uf uf-arrow-up"
      })), /*#__PURE__*/React.createElement("span", {
        // onClick={()=> minusDisabled?'':this.handleBtnClick('down')}
        onMouseDown: this.handleReduceMouseDown,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.clear();
        },
        onMouseUp: function onMouseUp() {
          return _this2.clear();
        },
        className: classnames("reduce", {
          disabled: minusDisabled,
          "disabled-cursor": disabledCursor
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: " uf uf-arrow-down"
      }))))));
    }
  }]);

  return InputNumber;
}(Component)) || _class);
InputNumber.propTypes = propTypes;
InputNumber.contextTypes = {
  beeLocale: PropTypes.object
};
export default InputNumber;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-input-number/src/InputNumber.js